var _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 326 326",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 29
  }, /*#__PURE__*/React.createElement("rect", {
    height: 296,
    rx: 78,
    width: 296,
    x: 15,
    y: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 163,
    r: 69
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 76,
    fill: "currentColor",
    r: 19
  })));
};
export default SvgInstagram;